import { __rest, __assign, __makeTemplateObject } from 'tslib';
import React, { forwardRef } from 'react';
import { styled } from 'styled-components';
import classnames from 'classnames';
import { HtmlSpan } from '../../reset/HtmlSpan/HtmlSpan.js';

var baseClassName = 'fi-visually-hidden';
var StyledVisuallyHidden = styled(function (props) {
  var forwardedRef = props.forwardedRef,
    passProps = __rest(props, ["forwardedRef"]);
  return /*#__PURE__*/React.createElement(HtmlSpan, __assign({
    forwardedRef: forwardedRef
  }, passProps));
}).withConfig({
  componentId: "sc-1s98eq1-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n"], ["\n  position: absolute;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n  overflow: hidden;\n"])));
var VisuallyHidden = /*#__PURE__*/forwardRef(function (props, ref) {
  var className = props.className,
    passProps = __rest(props, ["className"]);
  return /*#__PURE__*/React.createElement(StyledVisuallyHidden, __assign({
    forwardedRef: ref
  }, passProps, {
    className: classnames(baseClassName, className)
  }));
});
VisuallyHidden.displayName = 'VisuallyHidden';
var templateObject_1;

export { VisuallyHidden };
//# sourceMappingURL=VisuallyHidden.js.map
